import React from 'react'
import t from '../Language/language'
import Api from '../../Api'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as languageSettings from '../Language/languageSettings'
import CommonLoader from '../Alerts/CommonLoader'
import { checkResetPasswordLinkExpiry, resetPassword } from '../../actions/users'
import './ResetPassword.css'
class ResetPassword extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      currentLanguage: languageSettings.getCurrentLanguage(),
      isvalid: true,
      errorMessage: [],
      isSuccess: false,
      successMessage: '',
      successMessageDetail: '',
      newPassword: '',
      confirmPassword: '',
      isLinkExpired: false,
      resetUID: '',
      showMainSection: true,
      showCommonLoader: false
    }
    this.api = new Api()
    this.handleChange = this.handleChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  componentWillMount () {
    let resetUID = this.props.match.params.ruid.split('=')
    this.setState({ resetUID: resetUID[1] })
  }
  componentDidMount () {
    // APi to check password expiration link
    const data = {
      resetUID: this.state.resetUID
    }
    // Making redux action call to check the expiry link.
    this.props.checkResetPasswordLinkExpiry(data, result => {
      let errors = []
      if (result.isLinkExpired) {
        let language = this.state.currentLanguage
        errors.push(t[language].passwordexpire)
        this.setState({ isLinkExpired: true, errorMessage: errors, showMainSection: false })
      }
    })
  }
  // Hanlding the input change and updating to state.
  handleChange (event) {
    let data = this.state
    const name = event.target.name
    data[name] = event.target.value
    this.setState(data)
  }
  // Handling the validation.
  handleValidation () {
    let language = this.state.currentLanguage
    let errors = []
    let newPassword = this.state.newPassword
    let confirmPassword = this.state.confirmPassword
    // Password Validation
    var relower = new RegExp('[a-z]{1,}')
    var reupper = new RegExp('[A-Z]{1,}')
    var renumeric = new RegExp('[0-9]{1,}')
    if (newPassword.indexOf(' ') > 0) {
      errors.push(t[language].newPasswordcontainblank)
    }
    if (confirmPassword.indexOf(' ') > 0) {
      errors.push(t[language].confirmasswordcontainblank)
    }
    if (newPassword === confirmPassword) {
      if (newPassword.length >= 8 && newPassword.length <= 16) {
        if (!relower.test(newPassword)) {
          errors.push(t[language].newPasswordlowercase)
        }
        if (!reupper.test(newPassword)) {
          errors.push(t[language].newPassworduppercase)
        }
        if (!renumeric.test(newPassword)) {
          errors.push(t[language].newPasswordnumber)
        }
        if (!relower.test(newPassword) || !reupper.test(newPassword) || !renumeric.test(newPassword)) {
          errors.push(t[language].newPasswordinvalid)
        }
      } else {
        errors.push(t[language].newPasswordsize)
      }
      if (confirmPassword.length >= 8 && confirmPassword.length <= 16) {
        if (!relower.test(confirmPassword)) {
          errors.push(t[language].confirmPasswordlowercase)
          // errors.push('Invalid new password. Confirmed Password must contain at least 1 lowercase character.')
        }
        if (!reupper.test(confirmPassword)) {
          errors.push(t[language].confirmPassworduppercase)
        }
        if (!renumeric.test(confirmPassword)) {
          errors.push(t[language].confirmPasswordnumber)
        }
        if (!relower.test(confirmPassword) || !reupper.test(confirmPassword) || !renumeric.test(confirmPassword)) {
          errors.push(t[language].confirmpasswordinvalid)
        }
      } else {
        errors.push(t[language].confirmPasswordsize)
      }
    } else {
      errors.push(t[language].passwordmisMatch)
    }
    this.setState({ errorMessage: errors })
    if (errors.length > 0) {
      this.setState({ isvalid: false })
      return false
    } else {
      this.setState({ isvalid: true })
    }

    return true
  }
  // Handling the form submit.
  handleSubmit () {
    let errors = []
    let language = this.state.currentLanguage
    if (this.handleValidation()) {
      this.setState({ showCommonLoader: true })
      const data = {
        resetUID: this.state.resetUID,
        newPassword: this.state.newPassword,
        confirmPassword: this.state.confirmPassword,
        language: language
      }
      this.props.resetPassword(data, result => {
        if (result.status === true) {
          if (result.isLinkExpired === true) {
            errors.push(t[language].passwordexpire)
            this.setState({ isLinkExpired: true, errorMessage: errors, showMainSection: false })
          } else {
            this.setState({ showCommonLoader: true, isSuccess: true, showMainSection: false, successMessage: t[language].passwordresetconfirm })
          }
        } else {
          errors.push(t[language].passwordlinkinvalid)
          this.setState({ errorMessage: errors, isvalid: false, showCommonLoader: false })
        }
      })
    }
  }
  // Main render method.
  render () {
    let language = this.state.currentLanguage
    const populateError = (errors) => {
      return errors.map((error, i) => {
        return <li key={i}>{error}</li>
      })
    }
    return (
      <div id='resetContent'>
        <div className='status-messages'>
          <div className={'alert alert-danger errors ' + (this.state.isLinkExpired ? 'show' : 'hide')} >
            <ul> {populateError(this.state.errorMessage)}</ul>
          </div>
        </div>
        <div className='status-messages'>
          <div className={'alert alert-danger errors ' + (this.state.isvalid ? 'hide' : 'show')} >
            <ul> {populateError(this.state.errorMessage)}</ul>
          </div>
        </div>
        <div className={this.state.isSuccess ? 'show' : 'hide'}>
          <div className='forms clear'>
            <div className='appr' >
              <h3 style={{ 'fontSize': '28px' }}>{this.state.successMessage}</h3>
              <p style={{ 'fontSize': '16px' }}>{t[language].please} <a style={{ 'color': '#D41B3E','fontSize': '16px', 'textDecoration': 'none' }} href='/'> {t[language].login} </a> {t[language].toyouraccount}</p>
            </div>
          </div>
        </div>
        <section className={'report-container ' + (this.state.showMainSection ? 'show' : 'hide')}>
          {this.state.showCommonLoader ? <CommonLoader showLoader={this.state.showCommonLoader} message={'Loading...'} /> : ''}
          <div className={'resetPasswordinfo ' + (this.state.showCommonLoader ? 'hide' : 'show')}>
            <div className='forms'>
              <table className='user_reset_password'>
                <tbody>
                  <tr>
                    <th>
                      <label className='newPassword' key='newPassword'> {t[language].newpassword}</label>
                    </th>
                    <td>
                      <input className='loginInputs' type='password' name='newPassword' onChange={this.handleChange} />
                    </td>
                  </tr>
                  <tr>
                    <th>
                      <label className='confirmPassword' key='confirmPassword'>{t[language].confirmpasswordcolon}</label>
                    </th>
                    <td>
                      <input className='loginInputs' type='password' name='confirmPassword' onChange={this.handleChange} />
                    </td>
                  </tr>
                  <tr>
                    <td />
                    <td className='btn_reset_password_td'>
                      <span className='btn_reset_password'>
                        <input type='submit' value={t[language].resetpassBtn} onClick={this.handleSubmit} translate='' key='resetpassBtn' />
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <th colSpan='2' className='passinfo'>
                      <h6 translate='' key='passwordrequirements'>{t[language].PasswordRequirements}</h6>
                      <ul>
                        <li translate='' key='lengthofpasswordLi'>{t[language].ResetPasswordLength}</li>

                        <li translate='' key='passwordblankLi'>{t[language].ResetPasswordBlank}</li>
                        <li><span translate='' key='passwordgroupsLi'>{t[language].ResetPasswordGroup}</span>
                          <ul>
                            <li translate='' key='passwordgroupupperLi'>{t[language].ResetPasswordGroupUpperCase}</li>
                            <li translate='' key='passwordgrouplowerLi'>{t[language].ResetPasswordGroupLowerCase}</li>
                            <li translate='' key='passwordgroupnumberLi'>{t[language].ResetPasswordGroupNumerals}</li>
                          </ul>
                        </li>
                      </ul>
                    </th>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </section>
        <div className={this.state.isLinkExpired === true ? 'show' : 'hide'}>
          <h5 className='forgot_up'><a className='forgot_up' href='/pg=ManageAccount&st=rq'>{t[language].forgotpass}</a></h5>
        </div>
      </div>
    )
  }
}
// Updating the state from redux store.
function mapStateToProps (state) {
  return {
  }
}
// Binding the redux actions.
function matchDispatchToProps (dispatch) {
  return bindActionCreators(
    {
      checkResetPasswordLinkExpiry: checkResetPasswordLinkExpiry,
      resetPassword: resetPassword
    }, dispatch
  )
}
export default connect(mapStateToProps, matchDispatchToProps)(ResetPassword)



// WEBPACK FOOTER //
// ./src/components/ResetPassword/ResetPassword.js